import styled from 'styled-components'
import { Empty } from 'antd'

export const CasesTableContainer = styled.div`
    width: 100%;
    height: 100%;
    background: #f8f9fa;
    overflow-y: auto;
    padding: 20px;
    display: flex;
    flex-direction: column;
`

export const LoadingTableContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 400px;
`

export const TableContentWrapper = styled.div`
    padding: 20px;
`

export const EmptyState = styled(Empty)`
    margin-top: 60px;
    color: #8c8c8c;
`

export const SectionHeader = styled.div`
    font-size: 13px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    color: ${props => props.$isRenewal ? '#b44a2e' : '#475569'};
    padding: 8px 0;
    margin-top: ${props => props.$isRenewal ? '28px' : '0'};
    margin-bottom: 12px;
    border-bottom: 2px solid ${props => props.$isRenewal ? '#fed7aa' : '#e2e8f0'};
    display: flex;
    align-items: center;
    gap: 8px;

    &::before {
        content: '';
        display: inline-block;
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background: ${props => props.$isRenewal ? '#b44a2e' : '#059669'};
    }
`